<template>
    <div class="modal fade" tabindex="-1" :id="id" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
          <form id="kt_modal_form_project" @submit.prevent="updateProject" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('tasks.setCompleteDate') }}</h5>    
              </div>
              <div class="modal-body">
                <RequiredText /> 
                <div class="row">
                  <InputDate
                      :parent-id="'#'+id"
                      containerClass="col-12 mb-5"
                      :name="'recurrent-expense-start-date'+id"
                      :label="$t('recurrentExpense.label.endDate')"
                      :inputClass="'form-control form-control-sm form-control-solid'"
                      :isRequired="true"
                      size="lg"
                      :placeholder="$t('recurrentExpense.placeholder.endDate')"
                      v-model="formData.end_date"
                      dateFormat="d-m-Y H:i"
                      enableTime
                  />
                </div>
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps,ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import InputDate from "@/components/InputDate.vue";
import RequiredText from '@/components/RequiredText.vue';

const store = useStore()

const emit = defineEmits(['load', 'cancel'])
const props = defineProps({
  formEdit:{
      type:Object,
      default:{}
  },
  id:{type: String, default:"add_task_users"} ,
  users:{type: Array, default:[]} 

})

const formData = ref(props.formEdit)
const isLoading = ref(false)



watch(() => props.formEdit, (value) => {
    formData.value = props.formEdit
}, { deep: true })


function closeModal() {
  $('#'+props.id).modal('toggle')
  emit('cancel', {id: props.formEdit.task_id, source: props.formEdit.source })
}

function updateProject() {
  isLoading.value = true
  store.dispatch('tasks/changeTaskStatut', formData.value)
      .then(res => {
        window.toastr.success(i18n.global.t("notification.task_updated"))
        emit('load')
        formData.value={
          task_id: "",
          task_status_id: "",
          end_date: "",
          users: [],
          source: ''
        }
        isLoading.value = false
        $('#'+props.id).modal('toggle')
      })
      .catch(er => {
        //closeModal()
      })
      .finally(() => {
        isLoading.value = false
        emit('load')
      })
}





</script>
